export function isForbiddenError(error: unknown): boolean {
  return getErrorList(error).some(item => {
    const status = getErrorStatus(item)
    const message = getErrorMessage(item).toLowerCase()

    return status === 403 || message.includes('403') || message.includes('forbidden')
  })
}

function getErrorList(error: unknown): unknown[] {
  if (!error) {
    return []
  }

  if (Array.isArray(error)) {
    return error
  }

  if (Array.isArray((error as any).errors)) {
    return (error as any).errors
  }

  return [error]
}

function getErrorStatus(error: unknown): number | null {
  const rawStatus =
    (error as any)?.status ??
    (error as any)?.statusCode ??
    (error as any)?.extensions?.status ??
    (error as any)?.extensions?.statusCode ??
    (error as any)?.extensions?.http?.status

  const status = Number(rawStatus)

  return Number.isFinite(status) ? status : null
}

function getErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof (error as any)?.message === 'string') {
    return (error as any).message
  }

  try {
    return JSON.stringify(error)
  } catch (_) {
    return ''
  }
}
